import { InputDocumentConsent } from 'views/components/molecules/establishes/inputDocumentConsent';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { ConsentSecuritiesFormikType, FormErrorScrollTarget } from 'views/utils/accountEstablish';
import { AgreementDocumentInfo } from 'views/utils/graphql/graphql';

type ConsentSecuritiesTemplateType = {
  formik: ConsentSecuritiesFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
  };
  agreementDocuments: AgreementDocumentInfo[];
};

enum AgreementDocumentType {
  terms = 1,
  preContact = 2,
  infoSharing = 3,
  antisocial = 4,
}

export const ConsentSecuritiesTemplate = ({
  formik,
  buttonProps,
  agreementDocuments,
}: ConsentSecuritiesTemplateType) => {
  return (
    <>
      {/* FPG証券に対する同意事項 */}
      <div className="establishWrapper">
        {(!!formik.errors.securitiesTradingTermsAgreement || !!formik.errors.isReadSecuritiesTradingTermsAgreement) && (
          <FormErrorScrollTarget />
        )}
        <InputDocumentConsent
          title="証券取引約款についての同意"
          name="agreement"
          checkText="「証券取引約款」が適用されることに同意します"
          linkTitle="証券取引約款を確認する"
          linkUrl={agreementDocuments.find((x) => x.Type === AgreementDocumentType.terms)?.URL}
          batchDangerWord="必須"
          onClickLink={() => {
            formik.setFieldValue('isReadSecuritiesTradingTermsAgreement', true);
          }}
          isChecked={formik.values.securitiesTradingTermsAgreement}
          disabled={!formik.values.isReadSecuritiesTradingTermsAgreement}
          setIsChecked={(value) => {
            formik.setFieldValue('securitiesTradingTermsAgreement', value.target.checked);
          }}
          announceText='証券取引約款をご確認のうえ、チェックをお願いします'
          isEnable={
            !!formik.errors.securitiesTradingTermsAgreement || !!formik.errors.isReadSecuritiesTradingTermsAgreement
          }
          errorText={
            formik.errors.isReadSecuritiesTradingTermsAgreement || formik.errors.securitiesTradingTermsAgreement
          }
        />
      </div>

      <div className="establishWrapper">
        {(!!formik.errors.preContractAgreement || !!formik.errors.isReadPreContractAgreement) && (
          <FormErrorScrollTarget />
        )}
        <InputDocumentConsent
          title="金銭・有価証券等の預託および記帳に関する契約締結前交付書面の確認"
          name="documentGrant"
          checkText="「金銭・有価証券等の預託および記帳に関する契約締結前交付書面」を確認し、内容を理解しました"
          linkTitle="金銭・有価証券等の預託および記帳に関する契約締結前交付書面を確認する"
          linkUrl={agreementDocuments.find((x) => x.Type === AgreementDocumentType.preContact)?.URL}
          batchDangerWord="必須"
          onClickLink={() => {
            formik.setFieldValue('isReadPreContractAgreement', true);
          }}
          isChecked={formik.values.preContractAgreement}
          disabled={!formik.values.isReadPreContractAgreement}
          setIsChecked={(value) => {
            formik.setFieldValue('preContractAgreement', value.target.checked);
          }}
          announceText='契約締結前交付書面をご確認のうえ、チェックをお願いします'
          isEnable={!!formik.errors.preContractAgreement || !!formik.errors.isReadPreContractAgreement}
          errorText={formik.errors.isReadPreContractAgreement || formik.errors.preContractAgreement}
        />
      </div>

      <div className="establishWrapper">
        {(!!formik.errors.informationSharingAgreement || !!formik.errors.isReadInformationSharingAgreement) && (
          <FormErrorScrollTarget />
        )}
        <InputDocumentConsent
          title="情報共有についての同意"
          name="infoSharing"
          checkText="「情報の相互提供・共有に関する同意書」の内容を理解の上、同意します"
          linkTitle="情報の相互提供・共有に関する同意書を確認する"
          linkUrl={agreementDocuments.find((x) => x.Type === AgreementDocumentType.infoSharing)?.URL}
          batchDangerWord="必須"
          onClickLink={() => {
            formik.setFieldValue('isReadInformationSharingAgreement', true);
          }}
          isChecked={formik.values.informationSharingAgreement}
          disabled={!formik.values.isReadInformationSharingAgreement}
          setIsChecked={(value) => {
            formik.setFieldValue('informationSharingAgreement', value.target.checked);
          }}
          announceText='情報共有同意書をご確認のうえ、チェックをお願いします'
          isEnable={!!formik.errors.informationSharingAgreement || !!formik.errors.isReadInformationSharingAgreement}
          errorText={formik.errors.isReadInformationSharingAgreement || formik.errors.informationSharingAgreement}
        />
      </div>

      <div className="establishWrapper">
        {(!!formik.errors.antiSocialForcesCheckAgreement || !!formik.errors.isReadAntiSocialForcesCheckAgreement) && (
          <FormErrorScrollTarget />
        )}
        <InputDocumentConsent
          title="反社会的勢力ではないことの同意"
          name="antisocial"
          batchDangerWord="必須"
          onClickLink={() => {
            formik.setFieldValue('isReadAntiSocialForcesCheckAgreement', true);
          }}
          checkText="「反社会的勢力ではないことの表明・確約に関する同意」の内容を理解の上、同意します"
          linkTitle="反社会的勢力ではないことの表明・確約に関する同意を確認する"
          linkUrl={agreementDocuments.find((x) => x.Type === AgreementDocumentType.antisocial)?.URL}
          isChecked={formik.values.antiSocialForcesCheckAgreement}
          disabled={!formik.values.isReadAntiSocialForcesCheckAgreement}
          setIsChecked={(value) => {
            formik.setFieldValue('antiSocialForcesCheckAgreement', value.target.checked);
          }}
          announceText='反社会的勢力ではないことの表明・確約に関する同意をご確認のうえ、チェックをお願いします'
          isEnable={
            !!formik.errors.antiSocialForcesCheckAgreement || !!formik.errors.isReadAntiSocialForcesCheckAgreement
          }
          errorText={formik.errors.isReadAntiSocialForcesCheckAgreement || formik.errors.antiSocialForcesCheckAgreement}
        />
      </div>
      {buttonProps && (
        <div className="establishWrapper">
          <div className="establishWrapper_buttons">
            <Button {...buttonProps.prevButtonProps} />
            <Button {...buttonProps.nextButtonProps} />
          </div>
        </div>
      )}
    </>
  );
};
